import { render } from "./ItemTreeIndex.vue?vue&type=template&id=0cabb534&scoped=true&ts=true"
import script from "./ItemTreeIndex.vue?vue&type=script&lang=ts"
export * from "./ItemTreeIndex.vue?vue&type=script&lang=ts"

import "./ItemTreeIndex.vue?vue&type=style&index=0&id=0cabb534&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cabb534"]])

export default __exports__